import { CircularProgress } from '@mui/material';
import './circularprogress.component.css';

const CircularIndeterminate = () => (
  <div className="center" data-testid="circular-progress-container">
    <p data-testid="loading-text">Loading...</p>
    <CircularProgress data-testid="circular-progress" />
  </div>

);

export default CircularIndeterminate;
